import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MyServerDataSourceService } from '../../../services/my-server-data-source.service';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import { RoutinesService } from '../../../services/routines.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { MyToasterService } from '../../../services/my-toaster.service';
import { ProcessStatusService } from '../../../services/process-status.service';

@Component({
	selector: 'app-datagrid',
	templateUrl: './datagrid.component.html',
	styleUrls: ['./datagrid.component.scss']
})
export class DatagridComponent implements OnInit {

	//Docs: https://akveo.github.io/ng2-smart-table/#/

	//Colunas do grid
	@Input() columns: any = {};

	//Rotina da página atual
	@Input() routine;

	//Método para busca de dados na api
	@Input() apiMethod: string = '';

	//Parâmetro para travar a exclusão
	@Input() canDelete: boolean = true;

	//Parâmetro para travar a exclusão
	@Input() canInsert: boolean = true;

	//Parâmetro para travar a edição
	@Input() canEdit: boolean = true;

	//Campo a ser usado na passagem de parametro para o form de edição
	@Input() primaryKey: string = '';

	//Navigate para o form de edição -> Se não for passado, não aparece botão de inclusão ou edição
	@Input() formPage = [];

	//Envia parametros de filtro extras para a api
	@Input() params: Object = {};

	//@param checkbox to select multiple or single rows
	@Input() selectMode: string = 'single'

	settings: any = {
		mode: "external",
		selectMode: 'single',
		noDataMessage: 'Carregando registros...',
		actions: {
			add: false,
			edit: false,
			delete: false,
			columnTitle: 'Ações',
			position: 'right'
		},
		add: {
			addButtonContent: 'Cadastro'
		},
		edit: {
			editButtonContent: '<i class="nb-edit"></i>'
		},
		delete: {
			deleteButtonContent: '<i class="nb-trash"></i>'
		},
		pager: {
			perPage: 20
		},
		// rowClassFunction: (data) => console.log(data)

	};

	source: MyServerDataSourceService;

	constructor(
		private http: Http,
		private myToaster: MyToasterService,
		private processStatusService: ProcessStatusService,
		private routinesService: RoutinesService,
		private session: SessionStorageService,
		public router: Router,
		private route: ActivatedRoute,
	) {}

	ngOnInit() {

		//Pode excluir ou editar?
		this.routinesService.buscaRealizada.then(() => {

			let hashForm = this.formPage.length;

			if (this.columns[this.primaryKey])
				this.columns[this.primaryKey].width = '90px';

			this.settings.actions.add = this.canInsert && hashForm && this.routinesService.verificaPermissao(this.routine, 'Insere');
			this.settings.actions.edit = this.canEdit && hashForm && this.routinesService.verificaPermissao(this.routine, 'Edita');
			this.settings.actions.delete = this.canDelete && this.routinesService.verificaPermissao(this.routine, 'Exclui');
			this.settings.columns = this.columns;
			this.settings.selectMode = this.selectMode;

			//Monta as configurações
			let dataSouceConf = {
				endPoint: environment.api + this.apiMethod,
				dataKey: 'data.data',
				totalKey: 'data.x-total-count'
			};

			//Recebe os dados
			this.source = new MyServerDataSourceService(
				this.http,
				dataSouceConf,
				this.session,
				this.router,
				this.params
			);

			this.settings.noDataMessage = 'Nenhum registro encontrado';
			this.settings = Object.assign({}, this.settings);
		});
	}

	onEdit(event) {

		let editNavigatePage = this.formPage;

		editNavigatePage.push(event.data[this.primaryKey]);

		this.router.navigate(editNavigatePage);
	}

	onAdd(event) {
		this.router.navigate(this.formPage);
	}

	onDelete(event) {
		if (window.confirm('Deseja realmente excluir?')) {
			this.source.myDelete(environment.api + this.apiMethod + event.data[this.primaryKey]).then(() => {
				this.source.refresh();
			}).catch(error => {
				this.myToaster.showErrorToast('Exclusão não realizada', error);
			});
		}
	}

	onUserRowSelect(event){
		const {
			selected,
			source,
		} = event
		const processIds = selected.map(({ProcessoId}) => ProcessoId)
		const filters = source.__params
		let previousStatusId = this.route.snapshot.params['statusId']
		this.processStatusService.add({
			filters,
			processIds,
			statusToBeUpdatedTo: parseInt(previousStatusId),
		})
	}
}


// WEBPACK FOOTER //
// ./src/app/components/datagrid/datagrid.component.ts